import { render, staticRenderFns } from "./Menumanagement.vue?vue&type=template&id=def18498&scoped=true"
import script from "./Menumanagement.vue?vue&type=script&lang=js"
export * from "./Menumanagement.vue?vue&type=script&lang=js"
import style0 from "./Menumanagement.vue?vue&type=style&index=0&id=def18498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def18498",
  null
  
)

export default component.exports